export const sliceNames = {
  USER: "USER",
  TIME_OFF: "TIME_OFF",
  EMPLOYEES: "EMPLOYEES",
  WORKLOAD: "WORKLOAD",
  OPEN_GANT_IDS: "OPEN_GANT_IDS",
  DASHBOARD: 'DASHBOARD'
};
